import { makeStyles } from '@material-ui/styles';

export default makeStyles((theme) => ({
    appName: {
        fontSize: '32px',
        color: '#272727',
        opacity: '1',
        marginTop: '10px',
        marginBottom: '10px'
    },
    appStatus: {
        color: `#3391FF !important`,
        marginLeft: '10px',
        borderRadius: '5px !important',
        border: `1px solid #3391FF !important`,
        backgroundColor: '#FFF !important'
    },
    appChip: {
        color: `#3391FF !important`,
        transform: 'scale(0.6)'
    },
    cardContainer: {
        padding: '18px',
        height: '100% !important',
        width: '100%',
        marginRight: '20px',
        borderRadius: '5px !important',
        marginBottom: '10px',
        position: 'relative'
    },
    nameResponsive: {
        [theme.breakpoints.down('sm')]: {
            marginLeft: '15px'
        }
    },
    cardHead: {
        fontSize: '16px',
        fontWeight: 'bold',
        marginTop: '2px',
        paddingBottom: '7px',
        color: '#4E4E4E'
    },
    cardText: {
        fontSize: '12px',
        paddingTop: '5px',
        paddingBottom: '50px',
        color: '#596780'
    },
    cardsOutline: {
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'wrap',
        margin: '25px 20px 10px 0px'
    },
    alignIcon: {
        position: 'absolute',
        bottom: '12px',
        right: '11px'
    },
    buttonIconCheck: {
        borderRadius: '20px',
        border: 'none !important',
        background: '#ABF5D2',
        padding: '4px 6px',
        cursor: 'pointer'
    },
    buttonIconAdd: {
        borderRadius: '20px',
        border: 'none !important',
        padding: '4px 6px',
        cursor: 'pointer',
        paddingTop: '4px !important'
    },
    iconCheck: {
        color: '#016644'
    },
    fixIcon: {
        minHeight: '90px'
    }
}));
